import { DizionarioModel } from "../shared/dizionario.model";

export class BrogliaccioSearchModel {

    dataDal?:Date;
    dataAl?:Date;
    idstato?:number;

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/brogliacci/brogliaccio-search.model.ts